import { withMetrics } from 'client/data/api/api-metrics';
import { EdmundsAPI } from 'client/data/api/api-client';
import { get } from 'lodash-es';
import { createModelSegment } from 'client/data/luckdragon/segment';

const CAP_ONE_ELIGIBLE_VIN_URL =
  '/inventory/v5/find?dealerInfo.productFeatures.digitalRetail.credit.provider=CapitalOne';

export const TestCapitalOneModel = createModelSegment('testCapitalOne', [
  {
    /**
     * Example: https://qa-21-www.edmunds.com/api/inventory/v5/find?dealerInfo.productFeatures.digitalRetail.credit.provider=CapitalOne
     */
    path: 'vehiclesWithProviderCapitalOne',
    async resolve(_, context) {
      const MAX_SIZE = 5;
      try {
        const [usedVehiclesResponse, newVehiclesResponse] = await Promise.all([
          withMetrics(EdmundsAPI, context).fetchJson(`${CAP_ONE_ELIGIBLE_VIN_URL}&type=USED`),
          withMetrics(EdmundsAPI, context).fetchJson(CAP_ONE_ELIGIBLE_VIN_URL),
        ]);
        const usedVehicles = get(usedVehiclesResponse, 'results', []);
        const newVehicles = get(newVehiclesResponse, 'results', []);
        const result = usedVehicles.slice(0, MAX_SIZE).concat(newVehicles.slice(0, MAX_SIZE));

        return result
          .reduce((resultList, vehicle) => {
            const makeModel = get(vehicle, 'vehicleInfo.styleInfo.makeModel', '').split('|').join(' ');

            const year = get(vehicle, 'vehicleInfo.styleInfo.year');
            const vin = get(vehicle, 'vin');
            const type = get(vehicle, 'type', '').toLowerCase();
            resultList.push({ makeModel, year, vin, type });
            return resultList;
          }, [])
          .sort(({ type: typeFirst }, { type: typeSecond }) => typeFirst - typeSecond);
      } catch {
        return [];
      }
    },
  },
]);
